/* OXXRING v2 product page: pack selection, quantity summary, AJAX add to cart, mobile buy bar, gallery,
   section tabs, same-size grades, nearby sizes, empty-column hiding on the alternatives table. */
(function () {
  'use strict';

  function money(cents, format) {
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return withCommas;
    });
  }
  /* Per-piece price, same rules as snippets/oxx-ic-wp5-pp.liquid: < 1 cent "< $0.01"; under 10 cents 3 decimals
     ($0.068) so neighbouring pack tiers stay distinguishable; otherwise 2 decimals. Never 4 decimals. */
  function pp(cents, pack, format) {
    var c = cents / pack;
    if (c < 1) return '< ' + money(1, format);
    var mills = Math.round(c * 10);
    if (mills < 100) return money(0, format).replace('0.00', (mills / 1000).toFixed(3));
    return money(Math.round(c), format);
  }

  function initBuy(box) {
    var json = box.querySelector('[data-ic-buy-json]');
    var form = box.querySelector('[data-ic-buy-form]');
    if (!json || !form) return;
    var data = JSON.parse(json.textContent);
    var fmt = data.moneyFormat;
    var byId = {}; data.variants.forEach(function (v) { byId[v.id] = v; });
    var base = byId[data.base];
    var qty = form.querySelector('[data-ic-qty-input]');
    var q = function (s) { return box.querySelector(s); };
    var bar = q('[data-ic-buybar]');

    function current() {
      var r = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      return r ? byId[r.value] : null;
    }
    function packs() { return Math.max(1, parseInt(qty.value, 10) || 1); }

    function render(pushUrl) {
      var v = current(); if (!v) return;
      var n = packs();
      var t = q('[data-ic-buy-total]'); if (t) t.textContent = money(v.price, fmt);
      var p = q('[data-ic-buy-pack]'); if (p) p.textContent = v.pack + ' pcs';
      var u = q('[data-ic-buy-pp]'); if (u && v.pack) u.textContent = pp(v.price, v.pack, fmt);
      var s = q('[data-ic-buy-save]');
      if (s && base && v.id !== base.id && v.pack && base.pack) {
        var save = Math.round((base.price / base.pack - v.price / v.pack) / (base.price / base.pack) * 100);
        s.hidden = !(save >= 5); s.textContent = save >= 5 ? '· ' + save + '% less per piece than the ' + base.pack + '-piece pack' : '';
      } else if (s) s.hidden = true;
      var sum = q('[data-ic-buy-sum]');
      if (sum) sum.innerHTML = data.unit
        ? n + ' × ' + money(v.price, fmt) + ' = <b>' + money(v.price * n, fmt) + '</b>'
        : n + ' pack' + (n > 1 ? 's' : '') + ' × ' + v.pack + ' pcs = <b>' + (v.pack * n).toLocaleString('en-US') + ' pieces</b> · ' + money(v.price * n, fmt);
      document.querySelectorAll('[data-ic-sku]').forEach(function (el) { if (v.sku) el.textContent = v.sku; });
      var add = q('[data-ic-buy-add]'); if (add) add.disabled = !v.available;
      var now = q('[data-ic-buy-now]'); if (now) now.disabled = !v.available;
      var st = q('[data-ic-buy-state]'); if (st) st.textContent = v.available ? 'Available to order' : 'Option unavailable';
      if (bar) {
        var bt = bar.querySelector('[data-ic-buybar-total]'); if (bt) bt.textContent = money(v.price * n, fmt);
        var bp = bar.querySelector('[data-ic-buybar-pack]');
        if (bp) {
          var lab = form.querySelector('input[name="id"]:checked');
          lab = lab && lab.closest('label') && lab.closest('label').querySelector('.ic-pack__qty');
          bp.textContent = data.unit ? (n > 1 ? n + ' items' : '1 item') : 'for ' + (v.pack * n).toLocaleString('en-US') + ' pcs';
        }
        var ba = bar.querySelector('[data-ic-buybar-add]'); if (ba) ba.disabled = !v.available;
      }
      qty.min = v.min; qty.step = v.inc;
      if (pushUrl && window.history.replaceState) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); }
    }

    form.addEventListener('change', function (e) { if (e.target.name === 'id') render(true); });
    var renderTimer = 0;
    qty.addEventListener('input', function () {
      clearTimeout(renderTimer);
      renderTimer = setTimeout(function () { render(false); }, 80);
    });
    box.querySelectorAll('[data-ic-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = current(); var step = (v && v.inc) || 1; var min = (v && v.min) || 1;
        qty.value = Math.max(min, packs() + step * parseInt(b.getAttribute('data-ic-qty-step'), 10));
        clearTimeout(renderTimer);
        render(false);
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      var btn = e.submitter || form.querySelector('[data-ic-buy-add]');
      var isBuyNow = btn && btn.hasAttribute('data-ic-buy-now');
      if (isBuyNow && !window.fetch) { form.action = '/cart'; return; }
      e.preventDefault();
      var v = current(); if (!v || !v.available) return;
      var addBtn = q('[data-ic-buy-add]'), nowBtn = q('[data-ic-buy-now]'), msg = q('[data-ic-buy-msg]');
      var bbtn = bar && bar.querySelector('[data-ic-buybar-add]');
      if (isBuyNow) {
        if (nowBtn) { nowBtn.disabled = true; nowBtn.textContent = 'Processing…'; }
        fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: packs() }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            msg.hidden = false; msg.className = 'ic-buy__msg ic-buy__msg--err'; msg.textContent = err.message;
            if (nowBtn) { nowBtn.disabled = !v.available; nowBtn.textContent = 'Buy now'; }
          });
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
        if (bbtn) { bbtn.disabled = true; bbtn.textContent = 'Adding…'; }
        fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: packs() }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
          .then(function () {
            msg.hidden = false; msg.className = 'ic-buy__msg ic-buy__msg--ok';
            msg.innerHTML = 'Added to cart. <a class="ic-link" href="' + ((window.routes && window.routes.cart_url) || '/cart') + '">View cart and check out →</a>';
            if (bar) { var bc = bar.querySelector('[data-ic-buybar-cart]'); if (bc && bbtn) { bbtn.hidden = true; bc.hidden = false; } }
            document.dispatchEvent(new CustomEvent('oxx:cart:changed'));
            fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
              document.querySelectorAll('[data-ic-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-count', c.item_count); });
            }).catch(function () {});
            if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'oxx-ic-product' });
          })
          .catch(function (err) { msg.hidden = false; msg.className = 'ic-buy__msg ic-buy__msg--err'; msg.textContent = err.message; if (bar) msg.scrollIntoView({ block: 'center' }); })
          .then(function () {
            if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = 'Add to cart'; }
            if (bbtn) { bbtn.disabled = !v.available; bbtn.textContent = 'Add to cart'; }
          });
      }
    });

    /* Mobile buy bar: visible only while the in-box Add to cart button is off screen (CSS limits it to < 990 px). */
    var main = q('[data-ic-buy-add]');
    if (bar && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var seen = es[es.length - 1].isIntersecting;
        bar.hidden = seen; document.documentElement.classList.toggle('ic-has-buybar', !seen);
      }, { threshold: 0 }).observe(main);
    }
    render(false);
  }

  /* Gallery: a scroll-snap track; thumbs scroll to a slide and follow the visible slide. */
  function initGallery(g) {
    var track = g.querySelector('[data-ic-gallery-track]');
    var thumbs = [].slice.call(g.querySelectorAll('[data-ic-gallery-go]'));
    if (!track || !thumbs.length) return;
    var mark = function (i) { thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); }); };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); mark(i); });
    });
    var tm = 0;
    track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 80); }, { passive: true });
  }

  /* Section tabs: active state follows the section in view; the active tab scrolls into view on mobile. */
  function initToc(root) {
    var toc = root.querySelector('[data-ic-toc]');
    if (!toc || !('IntersectionObserver' in window)) return;
    var links = [].slice.call(toc.querySelectorAll('a[href^="#"]'));
    var map = {};
    links.forEach(function (a) { var s = document.getElementById(a.getAttribute('href').slice(1)); if (s) map[s.id] = a; });
    var active = null;
    var set = function (a) {
      if (!a || a === active) return;
      if (active) active.removeAttribute('aria-current');
      a.setAttribute('aria-current', 'true'); active = a;
      if (toc.scrollWidth > toc.clientWidth) toc.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' });
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) set(map[x.target.id]); });
    }, { rootMargin: '-80px 0px -65% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
    var fade = function () { toc.classList.toggle('is-scrolled-end', toc.scrollLeft + toc.clientWidth >= toc.scrollWidth - 4); };
    toc.addEventListener('scroll', fade, { passive: true }); fade();
  }

  /* Alternatives table: hide columns that carry no information for any row (all "—", or all the same status). */
  function autoHide(root) {
    var table = root.querySelector('table[data-ic-autohide]');
    if (!table) return;
    var rows = [].slice.call(table.tBodies[0] ? table.tBodies[0].rows : []);
    if (!rows.length) return;
    var heads = [].slice.call(table.tHead.rows[0].cells);
    heads.forEach(function (th, i) {
      if (i === 0 || i === heads.length - 1) return;
      var texts = rows.map(function (r) { return r.cells[i] ? r.cells[i].textContent.replace(/\s+/g, ' ').trim() : ''; });
      var empty = texts.every(function (t) { return !t || t === '—' || /^quoted on request$/i.test(t); });
      var same = /ordering/i.test(th.textContent) && texts.every(function (t) { return t === 'Available to order'; });
      if (empty || same) { th.hidden = true; rows.forEach(function (r) { if (r.cells[i]) r.cells[i].hidden = true; }); }
    });
  }

  function initIndexFeatures(root) {
    var id = parseFloat(root.dataset.id), cs = parseFloat(root.dataset.cs);
    if (!(id > 0) || !(cs > 0) || !window.OXXIC) return;
    var sec = root.querySelector('[data-ic-nearby]');
    var grades = root.querySelector('[data-ic-grades]');
    var needGrades = grades && !grades.querySelector('[data-ic-grade-server]');
    var go = function () {
      window.OXXIC.sizeIndex(root.dataset.indexUrl).then(function (index) {
        if (needGrades) {
          var row = window.OXXIC.exact(index, id, cs)[0];
          var list = grades.querySelector('[data-ic-grades-list]');
          if (row && list) row.codes.forEach(function (c) {
            if (c.m === root.dataset.mat && c.h === root.dataset.hard) return;
            var li = document.createElement('li'); var a = document.createElement('a');
            a.className = 'ic-chip'; a.href = '/products/' + window.OXXIC.handleFor(index, row, c);
            a.textContent = window.OXXIC.MAT[c.m][0] + ' ' + c.h + 'A';
            li.appendChild(a); list.appendChild(li);
          });
          // No other grade at this size: say so, and offer a quote for another material instead of an empty comparison.
          if (list && list.children.length <= 1) {
            var label = grades.querySelector('[data-ic-grades-label]'), all = grades.querySelector('[data-ic-grades-all]');
            if (label) label.textContent = 'Only grade listed at this size';
            if (all && grades.dataset.icGradesAsk) { all.href = grades.dataset.icGradesAsk; all.textContent = 'Need another material at this size? Request a quote →'; }
          }
        }
        if (!sec) return;
        var near = window.OXXIC.nearby(index, id, cs, 8);
        if (!near.length) return;
        var nl = sec.querySelector('[data-ic-nearby-list]');
        near.forEach(function (n) {
          var li = document.createElement('li'); var a = document.createElement('a');
          a.href = '/pages/size-guide?view=find-o-rings&units=mm&id=' + n.row.id.toFixed(2) + '&cs=' + n.row.cs.toFixed(2) + '&source=pdp-nearby';
          a.innerHTML = '<span class="ic-num">' + n.row.id.toFixed(2) + ' × ' + n.row.cs.toFixed(2) + ' mm</span><small class="ic-num">ID ' + (n.dId >= 0 ? '+' : '') + n.dId.toFixed(2) + ' · CS ' + (n.dCs >= 0 ? '+' : '') + n.dCs.toFixed(2) + '</small><small>' + n.row.codes.length + ' grade' + (n.row.codes.length === 1 ? '' : 's') + '</small>';
          li.appendChild(a); nl.appendChild(li);
        });
        sec.hidden = false;
        var tl = root.querySelector('[data-ic-toc-nearby]'); if (tl) tl.hidden = false;
      }).catch(function () {});
    };
    if (needGrades) { go(); return; }
    // Load the size index only when the specifications block approaches the viewport.
    var anchor = root.querySelector('#specs');
    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '600px' });
      io.observe(anchor);
    } else go();
  }

  function boot() {
    document.querySelectorAll('[data-ic-buy]').forEach(initBuy);
    document.querySelectorAll('[data-ic-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-ic-pdp]').forEach(function (root) { initToc(root); autoHide(root); initIndexFeatures(root); });
  }
  if (window.OXXIC) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
